import React from 'react';
import './WelcomeScreen.css';

const WelcomeScreen = ({ name }) => {
    return (
        <div className="welcome-overlay">
            <div className="welcome-content">
                <img
                    src={require('../../assets/logos/Logo.png')}
                    alt="Sulash Logo"
                    className="welcome-logo"
                />
                <h1 className="welcome-text">
                    Seja bem-vindo(a), <span className="highlight-name">{name}</span>!
                </h1>
                <div className="loading-dots">
                    <span>.</span><span>.</span><span>.</span>
                </div>
            </div>
        </div>
    );
};

export default WelcomeScreen;
